/// Polyfill Array.from()

/* 사용 방법
<!-- 재고 뷰 버튼 이미지 -->
<div class="makeshop-stock-sellpia-btn" style="display:none">
    <a href="#layer-stock-list" onclick="__MakeshopStock.openLayout()" style="text-align:center;border: 1px solid #ccc;height:43px;line-height:40px;font-size:15px;display:block">실시간 재고현황 보기</a>
</div>

// 기본값
<script type='text/javascript'>
var _MakeshopSellpia = {key:'inna', type:'mobile'};
</script>
<script src="http://lbdog3.test.sellpia.com/js/loader.js" charset="UTF-8"></script>


// 기본값 Mobile
<script type='text/javascript'>
var _MakeshopSellpia = {key:'inna', type:'mobile'};
</script>
<script src="http://lbdog3.test.sellpia.com/js/MakeshopStock.js" charset="UTF-8"></script>

<script>
var _safe_virtual_tag_ = function(data) { return data ? data : null }
var _MakeshopSellpiaStockViewConfig_ = {
    config:{
        stock_view_btn_id : "makeshop-stock-sellpia-btn", // default : makeshop-stock-sellpia-btn
    },
    makeshop_info:{
        shop_info:_safe_virtual_tag_(<!--/json/shop_info/-->),
        product_info:_safe_virtual_tag_(<!--/json/brand_info/-->),
        options_info:_safe_virtual_tag_(<!--/json/option_info/-->),
        sellpiaSSID:_safe_virtual_tag_(<!--/json/sellpiaSSID/-->)
    }
}
</script>
<script src="https://sellpia-product.makeshop.co.kr/publish/js/loader.js" charset="UTF-8"></script>

<script src="https://sellpia-product.makeshop.co.kr/publish/js/MakeshopStock_Debug.js" charset="UTF-8"></script>
*/


import {MakeshopStock}  from "./MakeshopStock";

(function (){
    let __debug_test_data = {
        shop_info:{
            adminuser:'inna',
            is_mobile:true,
            design_type:"D3",
            is_login:false
        },
        product_info:{
            branduid:2025221,
            product_title:"[완제품]레오_나이키상품명 수정",
            option_category:[{
                title:"사이즈",
                is_mandatory:true,
                use_stock:true,
            }],
            use_provider_delivery:false,
            multi_option:true,
            option_type:"PS"
        },
        options_info:[
            {
                title:["1Q"],
                price:50000,
                img_url:false,
                use_basket:true,
                uid:"2"
            },
            {
                title:["2Q"],
                price:50000,
                img_url:false,
                use_basket:true,
                uid:"3"
            },
            {
                title:["3Q"],
                price:50000,
                img_url:false,
                use_basket:true,
                uid:"4"
            }
        ],
    }
    let __debug_test_data_backup = {
        shop_info:{
            shop_id:'inna',
            is_mobile:true,
            design_type:"D3",
            is_login:false
        },
        product_info:{
            branduid:2025221,
            product_title:"[완제품]레오_나이키상품명 수정",
            option_category:[{
                title:"사이즈",
                is_mandatory:true,
                use_stock:true,
            }],
            use_provider_delivery:false,
            multi_option:true,
            option_type:"PS"
        },
        options_info:[
            {
                title:["1Q"],
                price:50000,
                img_url:false,
                use_basket:true,
                uid:"2"
            },
            {
                title:["2Q"],
                price:50000,
                img_url:false,
                use_basket:true,
                uid:"3"
            },
            {
                title:["3Q"],
                price:50000,
                img_url:false,
                use_basket:true,
                uid:"4"
            }
        ],
        sellpiaSSID:"Y1ayi1XymGwf85IJzzd0lERh6RtO099RMARx2F8RN7k="
    }
    window.addEventListener('DOMContentLoaded', () => {
        // TODO try catch
        // try {
            window.__MakeshopStock = new MakeshopStock(
                {...window?._MakeshopSellpiaStockViewConfig_?.makeshop_info} || {},
                {
                    ...{ // default
                        stock_view_btn_id: "makeshop-stock-sellpia-btn",
                        stock_view_btn_display_allway: true, // TODO 개발 완료 후 false // 기본값 false
                        loadingCallback: ()=>{
                            if (window.optionJsonData?.basic) {
                                window.afterUpdateOptionsLayout({object:null, option_mode:"basic", current_idx: -1}); // 최초
                            }
                        },
                        display_option_text_use : true, // TODO 개발 완료 후 false 로 변경 // 룸페커 전용 // D4 전용
                        display_option_text : {
                            glue: " - ",
                            flag: ['today_display', undefined], // TODO 개발용 undefined ... 기본값 ['today_display']
                        }
                    }
                    , ...(window?._MakeshopSellpiaStockViewConfig_?.config || {})
                }
            );
            window.afterUpdateOptionsLayout = window.__MakeshopStock.makeshopOptionsTextUpdateCallBack

        // } catch (e) {
        //     console.log("%cMakeshop Stock By Sellpia Error : " + e.message , "color: red;");
        // }
        console.log("%cMakeshop Stock By Sellpia " + MakeshopStock.version, "color: blue");
    });
})()


